module.exports = __webpack_public_path__ + "static/media/465264__rvgerxini__quick-pop.6493d4f0.mp3";